__webpack_require__.p = "/2025-11-19-experiment-with-two-editor-instances/";